export default __webpack_public_path__ + "static/FancyMediaContentTwo-29a873b2bdfcf6e2fe82a9687574fcf8.webp";